import { ElementPositionAndSize } from "../helpers";
import { documentStore, uiStore } from "@/store/store";

export type DragHandleBehavior = {
  xProperty?: string /* this should be an array of properties... i.e. padding.left and padding.left */;
  yProperty?: string;
};

export type DragCallback = (
  elementPositionAndSize: ElementPositionAndSize,
  mouseDragInfo: ValidMouseDragInfo
) => void;

export type MouseDragInfo = ValidMouseDragInfo | false;

export type ValidMouseDragInfo = {
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
  lastXChange: number;
  lastYChange: number;
  totalXChange: number;
  totalYChange: number;
};

export function makeDragCallback(dragHandleBehavior: DragHandleBehavior) {
  return (
    elementPositionAndSize: ElementPositionAndSize,
    mouseDragInfo: ValidMouseDragInfo
  ) => {
    if (uiStore.activeElementId) {
      const combinatorFunction = (a: number, b: number) => {
        return a + b >= 0 ? a + b : 0;
      };

      /*

      for an image:
       - any drag anywhere only affects width

       for an image frame
        - we'd need percentages, not px widths

       for a button:
        - drag a corner proportionally increases paddings
        - drag middle side - incerases padding left and right
        - drag middle top or bottom - increases padding top and bottom
        
        
        /*

      top left - decrease x, decrease y
      top middle - decrease y
      top right - increase x, decrease y

      bottom left - decrease x, increase y
      bottom middle - increase y
      bottom right - increase x, increqase y

      left middle - decrease x
      right middle - increase x

      */

      if ("xProperty" in dragHandleBehavior && dragHandleBehavior.xProperty) {
        const controlPath = dragHandleBehavior.xProperty.replace(
          "%%CURRENTMEDIAQUERY%%",
          uiStore.currentBreakpoint.id
        );

        const newValue = combinatorFunction(
          elementPositionAndSize.width,
          mouseDragInfo.lastXChange
        );

        documentStore.throttledPropertyChanged({
          elementId: uiStore.activeElementId,
          path: controlPath,
          value: {
            number: newValue,
            unit: "px"
          },
          meta: {
            snapshotLabel: "Resize element"
          }
        });
      }

      if ("yProperty" in dragHandleBehavior && dragHandleBehavior.yProperty) {
        const controlPath = dragHandleBehavior.yProperty.replace(
          "%%CURRENTMEDIAQUERY%%",
          uiStore.currentBreakpoint.id
        );

        const newValue = combinatorFunction(
          elementPositionAndSize.height,
          mouseDragInfo.lastYChange
        );

        documentStore.throttledPropertyChanged({
          elementId: uiStore.activeElementId,
          path: controlPath,
          value: {
            number: newValue,
            unit: "px"
          },
          meta: {
            snapshotLabel: "Resize element"
          }
        });
      }
    }
  };
}
